/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFDataleakEvent
 */
export interface CRSFDataleakEvent {
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleakEvent
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFDataleakEvent
     */
    name: string;
}

/**
 * Check if a given object implements the CRSFDataleakEvent interface.
 */
export function instanceOfCRSFDataleakEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CRSFDataleakEventFromJSON(json: any): CRSFDataleakEvent {
    return CRSFDataleakEventFromJSONTyped(json, false);
}

export function CRSFDataleakEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDataleakEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'name': json['name'],
    };
}

export function CRSFDataleakEventToJSON(value?: CRSFDataleakEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'name': value.name,
    };
}

